module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var columns = widget.gridColumns(); 
    ; __append("\n")
    ;  var actions = widget.gridActions(); 
    ; __append("\n<tr on-click=\"onItemSelectClick\" class=\"")
    ; __append(escapeFn( item.providerid == context("provider.id") || item.private && item.acl[Security.AclAction.Write] ? "spl-form__classes__my" : "" ))
    ; __append("\">\n    ")
    ;  Util.each(columns, function (column) { 
    ; __append("\n    <td class=\"gridview-column\" data-column-name=\"")
    ; __append(escapeFn( column.name ))
    ; __append("\">\n        ")
    ; __append(escapeFn( widget.gridColumnContent(column, item) ))
    ; __append("\n    </td>\n    ")
    ;  }); 
    ; __append("\n    ")
    ;  Util.each(actions, function (action) { 
    ; __append("\n    ")
    ; 
        var enabled = true;

        if (Util.isDefined(action.enabled)) {
            if (Util.isFunction(action.enabled)) {
                enabled = !!action.enabled(item);
            } else {
                enabled = !!action.enabled;
            }
        }
    
    ; __append("\n    ")
    ;  if (enabled) { 
    ; __append("\n    <td class=\"gridview__action\" ")
    ; __append( action["on-click"] ? 'on-click="' + action["on-click"] + '"' : '' )
    ; __append(" ")
    ; __append( action["name"] ? 'data-name="' + action["name"] + '"' : '' )
    ; __append(">\n        <div\n            class=\"icon-16 ")
    ; __append( action.css ? action.css : '' )
    ; __append("\"\n            ")
    ; __append( action.title ? 'title="' + Html.encode(action.title) + '"' : '' )
    ; __append("\n            >\n            ")
    ; __append(escapeFn( action.title && !action.css ? action.title : "" ))
    ; __append("\n        </div>\n    </td>\n    ")
    ;  } else { 
    ; __append("\n    <td class=\"gridview__action\">\n        <div>\n        </div>\n    </td>\n    ")
    ;  } 
    ; __append("\n    ")
    ;  }); 
    ; __append("\n</tr>\n")
  }
  return __output.join("");

}